import { createFileRoute } from '@tanstack/react-router';
import StatusError from 'src/components/access/StatusError';

export const Route = createFileRoute('/access_/401')({
	component: UnauthorizedPage,
});

function UnauthorizedPage() {
	return (
		<StatusError>
			<div className="w-full flex flex-col items-center justify-center flex-grow mt-16">
				<div className="w-[300px] h-full flex flex-col justify-center items-center">
					<StatusError.Illustration src="/public/access_denied.svg" />
				</div>
				<StatusError.Label>It looks like you are not allowed to access this page</StatusError.Label>
				<StatusError.Section.Title>Please use the link you received in the invite</StatusError.Section.Title>
			</div>
		</StatusError>
	);
}
